import { Lock as LockIcon } from "@tamagui/lucide-icons";
import { Body3, ExternalLink, YStack } from "@medbillai/ui";
import { grantedSecurityUrl } from "@medbillai/utils/urls";
export const SignUpTrustBlock = () => {
  return <YStack alignItems="center" data-sentry-element="YStack" data-sentry-component="SignUpTrustBlock" data-sentry-source-file="SignUpTrustBlock.tsx">
      <YStack alignItems="center" gap="$sp1" maxWidth={318} data-sentry-element="YStack" data-sentry-source-file="SignUpTrustBlock.tsx">
        <LockIcon color="$iconSubtle" size="$iconSmall" strokeWidth={2.5} data-sentry-element="LockIcon" data-sentry-source-file="SignUpTrustBlock.tsx" />
        <Body3 color="$textSubtle" textAlign="center" data-sentry-element="Body3" data-sentry-source-file="SignUpTrustBlock.tsx">
          Granted takes privacy and HIPAA seriously with industry-leading
          encryption.{" "}
          <ExternalLink href={grantedSecurityUrl()} title="Learn more" target="_blank" textDecorationLine="underline" color="$textSubtle" data-sentry-element="ExternalLink" data-sentry-source-file="SignUpTrustBlock.tsx" />
        </Body3>
      </YStack>
    </YStack>;
};